import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog12 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>

        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        {/* Intro */}
        <p className="paragraph-content">
          Long queues. Forms that never end. Hidden fees that surprise you on
          payday.
          <br />
          You earn, you hustle, and somehow paise bachte hi nahi.
        </p>

        <p className="sub-paragraph-heading">The daily drain</p>

        <p className="paragraph-content">
          You know the feeling: a late-night fever, a hospital bill, or school
          fees that push you into panic.
          <br />
          Banks make saving feel like a long exam you didn’t sign up for.
          <br />
          Complex forms. Minimum balances. Calls that lead nowhere.
          <br />
          For someone who lives month-to-month, every rupee is a decision.
          <br />
          That constant small stress eats at everything.
        </p>

        <p className="sub-paragraph-heading">
          This isn’t luxury – it’s survival
        </p>

        <p className="paragraph-content">
          Imagine missing a school admission fee by a day.
          <br />
          Imagine your shop closing because you couldn’t pay a supplier on time.
          <br />
          That shame, the worry, the “kya hoga kal” – it grows when money tools
          are built for rich or expert users, not for you.
          <br />
          Seeing neighbors stack small wins while you stay stuck?
          <br />
          It stings. That’s not vanity – that’s status, security, and peace.
        </p>

        <p className="sub-paragraph-heading">Small habit, big difference</p>

        <p className="paragraph-content">
          Here’s one clean idea: make saving automatic and tiny.
          <br />
          kPaisa is built for everyday earners – start from ₹1 for digital gold,
          set tiny SIPs, or save ₹10–₹50 daily.
          <br />
          Auto-save takes the choice out of your pocket.
          <br />
          Need cash? Small loans in minutes, no long paperwork.
          <br />
          Simple dashboard, no confusing jargon, local language nudges, and
          gamified visuals that show progress – coins stacking, streaks, and
          small wins.
          <br />
          This isn’t about a big, risky bet. It’s about consistent
          micro-investing that compounds.
        </p>

        <p className="sub-paragraph-heading">Start with what you can’t miss</p>

        <p className="paragraph-content">
          Pick one habit tonight: save ₹50.
          <br />
          Not tomorrow. Tonight.
          <br />
          If you{" "}
          <a
            href="https://kleio.app.link/download"
            target="_blank"
            rel="noreferrer"
            style={{
              color: "#1155cc",
              textDecoration: "underline",
              fontWeight: 400,
              fontSize: "20px",
            }}
          >
            click the link
          </a>{" "}
          you’ll see a one-page ₹50 plan that builds an emergency buffer in
          months – not years.
          <br />
          No lectures. No complex maths. Just a step that fits in your daily
          life.
          <br />
          There’s a quiet feature inside that turns your spare change into gold
          grams – it’s simple and legal, and banks don’t like that people know
          about it.
          <br />
          Curious?{" "}
          <a
            href="https://kleio.app.link/download"
            target="_blank"
            rel="noreferrer"
            style={{
              color: "#1155cc",
              textDecoration: "underline",
              fontWeight: 400,
              fontSize: "20px",
            }}
          >
            Click to see how it works
          </a>
        </p>

        {/* FAQ */}
        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>

        <FaqAccordion>
          <h4 className="faq-question">Is this safe for small savers?</h4>
          <p className="faq-answer">
            Yes – low-ticket products, clear fees, and instant access. Built
            specifically for everyday users.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">How little can I start with?</h4>
          <p className="faq-answer">
            From ₹1 for digital gold. Saving ₹10–₹50 daily is a common and very
            effective habit.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">Do I need lots of documents?</h4>
          <p className="faq-answer">
            No. Basic KYC is enough for most micro-saving and micro-loan
            products.
          </p>
        </FaqAccordion>

        <br />
        <br />
      </div>
    </div>
  );
};

export default Blog12;
